<!-- <input type="search" [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($any($event))" /> -->
<input type="search" name="q" debounceTime="300" [(value)]="$query" />

<p>Search Term: {{ $query() }}</p>
<ul>
  @for(item of items; track item){
  <li>{{item.name}}</li>
  }
</ul>
<p>items: {{items | json}}</p>
